import(/* webpackMode: "eager" */ "/app/src/app/[lang]/leaderboards/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["GTMEvent"] */ "/app/src/features/google-tag-manager/components/GoogleTagManager.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CommunityStat"] */ "/app/src/features/leaderboards/components/communityStat/CommunityStat.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeaderboardsHeader"] */ "/app/src/features/leaderboards/components/header/LeaderboardsHeader.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Leaderboard"] */ "/app/src/features/leaderboards/components/leaderboard/Leaderboard.component.tsx");
